/**
 * @file Saga signing one contract: a 200 updates the store row's status and snackbars, a 207 opens the sign's partial dialog.
 * Failure path: catch → ErrorHandlerSequence with the route's expected errors → GLOBAL_CONTRACT_SIGN_FAILURE.
 */
import { call, put, select, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import { isContractIdOnly } from "../../Entity/Entities/Contract/PartialAnswer";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-contract-sign", bodyKey: "refusal-body-financial-processing-busy" },
  be_contract_not_found: { titleKey: "refusal-title-contract-sign", bodyKey: "refusal-body-contract-sign-not-found" },
  be_server_error: { titleKey: "refusal-title-contract-sign", bodyKey: "refusal-body-contract-sign-server-error" },
  be_contract_sign_failed: { titleKey: "refusal-title-contract-sign", bodyKey: "be_contract_sign_failed" }
};

export default function* contractSign(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTRACT_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_SIGN_REQUEST
    });

    const res = yield call(Http.post, `contract/${action.payload?.id}/sign`);
    const body = res.data.data;
    let contract: any = body;

    if (!isContractIdOnly(body)) {
      // The sign's body is a plain row, so the store row keeps its relations.
      const storedContract: any = yield select((state: any) =>
        state.app.contracts.find((storeContract: ContractInterface) => storeContract.id === body.id));

      contract = storedContract ?
        storedContract.reinitialize({ contractStatusId: body.contractStatusId }) :
        ContractFactory.create(body);

      yield put({
        type: Constants.PAGE_CONTRACT_UPDATE_SUCCESS,
        payload: {
          contract: contract
        }
      });
    }

    if (res.status === 207) {
      yield put({
        type: Constants.GLOBAL_REFUSAL_DIALOG_OPEN,
        payload: {
          titleKey: "partial-title-contract-sign",
          bodyKey: "partial-body-contract-sign"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-contract-signed-successfully"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, contract);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CONTRACT_SIGN_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractSign() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_SIGN_START, contractSign);
}
